module.exports = __webpack_public_path__ + "img/2.0c07c8ed.png";